import {createAction, props} from "@ngrx/store";
import {
  FilterDto, NoteMailDto, NoteTextDto,
  NoteTopic,
  SolutionItemGenericDto,
} from '@server-models';
import {IStoreList} from "@shared/interfaces/store-list.interface";

export const loadSolution= createAction(
  '[Shared Solution] Load Solution',
  props<{ missionId: number, filters?: FilterDto[], noteTopic?: NoteTopic }>()
);

export const loadSolutionSuccess= createAction(
  '[Shared Solution] Load Solution Success',
  props<{ list: IStoreList<SolutionItemGenericDto>, noteTopic?: NoteTopic }>()
);

export const appendSolutionPage= createAction(
  '[Shared Solution] Append Solution'
);

export const postSolutionItem= createAction(
  '[Shared Solution] Post Solution Item',
  props<{ note: NoteTextDto & NoteMailDto, solutionId: number }>()
);


